import React, { useState } from 'react';

import { useDebounce } from '../../hooks/use-debounce';
import FilterTranslations from '../../entities/filter/translations';
import { strings } from '../../localization/strings';

interface ComponentProps {
  initialState: FilterTranslations;
  filterState: FilterTranslations;
  onUpdate: (filters: FilterTranslations) => void;
}

export default function TranslationsFilter({ initialState, filterState, onUpdate }: ComponentProps) {
  const [inputValue, setInputValue] = useState<string>(filterState.search || initialState.search || '');

  const onDelayedTextChange = useDebounce((value: string) => {
    onUpdate({ ...filterState, search: value });
  }, 500);

  const onTextChange = (value: string) => {
    setInputValue(value);
    onDelayedTextChange(value);
  };

  const clearFilter = () => {
    setInputValue(initialState.search || '');
    onUpdate({ ...initialState });
  };

  return (
    <div className="border-b border-gray-200 bg-white">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-4 sm:px-6 lg:px-8">
        <div className="text-sm text-gray-500">
          {filterState.search ? (
            <button type="button" onClick={clearFilter} className="text-gray-500">
              {strings.filter.clearFilter}
            </button>
          ) : null}
        </div>
        <div className="w-full sm:w-96">
          <input
            id="search"
            name="search"
            className="block w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm placeholder-gray-500 focus:border-rose-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-rose-500 sm:text-sm"
            placeholder={strings.common.searchLabel}
            type="search"
            onChange={(event) => onTextChange(event.target.value)}
            value={inputValue}
          />
        </div>
      </div>
    </div>
  );
}
